export default __webpack_public_path__ + "static/media/stefan-footer-image-mobile.76bc6844.png";